<template>
  <div class="container-fluid">
    <div class="row overflow">
      <div class="col-md-9 col-8">
        <span
          :class="
            geo.area_type === 'administrative_area_level_1'
              ? 'level-1'
              : 'level-2'
          "
          v-if="!isEditing"
          >{{ geo.name }}</span
        >
        <input
          type="text"
          v-if="isEditing"
          @keyup.enter="handler"
          @focusout="handler"
          v-model="address"
        />
      </div>

      <div class="col-md-3 col-4 my-icons">
        <i
          v-if="!isEditing"
          title="Modifica"
          @click="edit"
          class="fas fa-pen orange"
        ></i>
        <i v-else class="fas fa-check green pointer" @click="edit"></i>

        <i
          title="Cancella"
          @click="elimina_area = geo.name"
          class="fas fa-trash red ml-5"
        ></i>

        <div class="conferma" v-if="elimina_area != null">
          <div class="modal-white container">
            <div class="row">
              <h1 class="col-md-12">
                Sei sicuro di voler cancellare questo area: {{ geo.name }}?
              </h1>
              <div class="col-md-3">
                <button class="belt-btn" @click="elimina_area = null">
                  Annulla
                </button>
              </div>
              <div class="col-md-9">
                <button class="belt-btn" @click="deleteDb()">
                  Prosegui con la cancellazione
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "aree-geo",
  props: ["geo"],
  data() {
    return {
      elimina_area: null,
      isEditing: false,
      address: null,
    };
  },
  mounted() {
    this.address = this.geo.name;
  },
  methods: {
    deleteDb: function () {
      axios({
        method: "get",
        url: window.location.origin + "/admin/shipping",
        params: {
          action: "delete-geoarea",
          id: this.geo.id,
        },
      }).then((res) => {
        this.$emit("refresh", true);
        //console.log(res.data.message);
      });
    },
    updateToDB: function () {
      axios({
        method: "get",
        url: window.location.origin + "/admin/shipping",
        params: {
          action: "update-geoarea",
          id: this.geo.id,
          address: this.address,
        },
      })
        .then((res) => {
          this.$emit("refresh", true);
        })
        .catch((err) => {
          console.log(err.response.data.message);
        });
    },
    handler: function () {
      this.update();
      this.updateToDB();
      this.$emit("refresh", true);
    },
    update: function () {
      this.isEditing = false;
    },
    edit: function () {
      this.isEditing = !this.isEditing;
    },
  },
};
</script>

<style lang="scss" scoped>
.container-fluid {
  input {
    width: 100%;
  }

  .level-1 {
    color: #000000;
  }

  .level-2 {
    color: #4d4d57;
  }

  .row.overflow {
    height: 70%;
    overflow-y: auto;

    svg {
      cursor: pointer;
    }

    svg:first-child {
      path {
        fill: goldenrod;
      }
    }

    svg:last-child {
      path {
        fill: red;
      }
    }
  }
  .my-icons {
    padding: 0;
  }
}
</style>
